module.exports = __webpack_public_path__ + "img/porsche.1e2a3fa6.png";